export default __webpack_public_path__ + "static/media/cerba-int.77df85f6.png";